var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#85D7B9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6981 37.3851L44.6664 60.4151C44.5115 60.5706 44.3275 60.6939 44.1249 60.7781C43.9222 60.8623 43.705 60.9056 43.4855 60.9056C43.2661 60.9056 43.0489 60.8623 42.8462 60.7781C42.6436 60.6939 42.4596 60.5706 42.3047 60.4151L33.398 51.5001C33.2432 51.3446 33.0592 51.2213 32.8565 51.1371C32.6539 51.0529 32.4366 51.0096 32.2172 51.0096C31.9978 51.0096 31.7805 51.0529 31.5779 51.1371C31.3753 51.2213 31.1912 51.3446 31.0364 51.5001C30.8809 51.655 30.7576 51.839 30.6734 52.0416C30.5892 52.2443 30.5459 52.4615 30.5459 52.6809C30.5459 52.9004 30.5892 53.1176 30.6734 53.3203C30.7576 53.5229 30.8809 53.7069 31.0364 53.8618L39.9464 62.7701C40.8863 63.7083 42.16 64.2352 43.488 64.2352C44.8161 64.2352 46.0898 63.7083 47.0297 62.7701L70.0597 39.7451C70.2149 39.5903 70.3381 39.4064 70.4221 39.2039C70.5061 39.0014 70.5494 38.7843 70.5494 38.5651C70.5494 38.3459 70.5061 38.1288 70.4221 37.9263C70.3381 37.7238 70.2149 37.5399 70.0597 37.3851C69.9049 37.2296 69.7208 37.1063 69.5182 37.0221C69.3156 36.938 69.0983 36.8946 68.8789 36.8946C68.6595 36.8946 68.4422 36.938 68.2396 37.0221C68.0369 37.1063 67.8529 37.2296 67.6981 37.3851Z",
    fill: "#85D7B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/ModalIcon.b8da9c0fea8df7a30b9537ce4c5be208.svg";
export { ForwardRef as ReactComponent };